define('viewModels/CoachingView',[
    'viewModels/ViewModel',
    'lib/knockout',
    'lib/lodash4',
    'services/authService',
    'services/userService',
    'services/qm/qualityAuth',
    'util/getPcAuthToken',
    'config',
], function (ViewModel, ko, _, authService, userService, qualityAuthService, getPcAuthToken, config) {
    'use strict';

    /**
     * A ViewModel to keep coaching logic seperate.
     *
     */
    var CoachingView = ViewModel.extend(function() {
        var self = this;

        self.coachingFeatureToggles = ko.observableArray();
        self.conversationUrl = window.top.location.href.split('/#')[0] + "/#/engage/admin/interactions/";
        self.conversationId = ko.observable("");
        self.conversationIds = self.computed(function(){
            return [self.conversationUrl + self.conversationId()];
        });
        self.noUrlConversationIds = self.computed(function(){
            return [self.conversationId()];
        });
        self.participants = ko.observableArray();
        self.agents = self.computed(function(){
            var participants =  self.participants().filter(function(participant) {
                return participant.purpose === 'agent';
            });
            return _.map(participants, function(participant) {
                return {
                    id: participant.userId,
                    name: participant.name
                };
            });
        });
        
        self.canScheduleCoaching = self.computed(function() {
            return self.agents() && self.agents().length > 0 &&
                qualityAuthService.canScheduleCoaching();
        });

        self.showModal = ko.observable(false);

        self.isActive = ko.observable(false);
        
        self.showCoachingModal = function(){
            self.showModal(true);
        };

        self.currentUser = self.computed(function(){
            return userService.currentUser();
        });

        // Need to use the window location to build an absolute path if it's not absolute already
        if (config.api.uri.indexOf('http') === 0)  {
            self.apiRoot = config.api.uri.replace(/\/api\/v[0-9]*/, '/api/v2');
        }else{
            self.apiRoot = window.location.origin + config.api.uri.replace(/\/api\/v[0-9]*/, '/api/v2');
        }
        

        self.modalClosed = function(event, data) {
            var wemModal = data.target;
            self.showModal(false);
            wemModal.resetModal();
        };

        self.authToken = self.computed(function(){
            return getPcAuthToken().authenticated.access_token;
        });

        self.permissions = ko.observableArray();
        self.permissionsPromise = self.computed(function(){
            return authService.getRawPermissions().then(function(rawPerms){
                self.permissions(rawPerms);
            });
        });
    });

    return CoachingView;
});
